import type {Connection} from '@package/shared'
import {Flex, Modal} from '@mantine/core'
import {UpdateForm as UpdateIcalSubscriptionForm} from '../forms/ical/UpdateForm.tsx'
import {UpdateForm as UpdateGitHubForm} from '../forms/github/UpdateForm.tsx'
import {UpdateForm as UpdateJiraForm} from '../forms/jira/UpdateForm.tsx'

type Props = {
  connection: Connection | undefined
  opened: boolean
  onClose: () => void
}

export const EditConnectionModal = ({connection, opened, onClose}: Props) => {
  if (!connection) return null

  return (
    <Modal opened={opened} onClose={onClose} title={'Edit connection'} size={'lg'}>
      <Flex direction={'column'} gap={'sm'}>
        {connection.type === 'ical-subscription' && (
          <UpdateIcalSubscriptionForm connection={connection} onSuccess={onClose} disabled={false} />
        )}
        {connection.type === 'github-api' && (
          <UpdateGitHubForm connection={connection} onSuccess={onClose} disabled={false} />
        )}
        {connection.type === 'jira-api' && (
          <UpdateJiraForm connection={connection} onSuccess={onClose} disabled={false} />
        )}
      </Flex>
    </Modal>
  )
}
